import { ActivityDetailed } from '@interfaces/api/activity-detailed'
import { axiosPut } from '@services/api/axios'

export const apiPublishActivity = async (id: number, publish: boolean) =>
  await axiosPut<{ publish: boolean }, ActivityDetailed>(`/external-app-plugin/activities/${id}/publish`, {
    publish
  })
